import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { n8nApiSlice } from "../../../../services/api";
import {
    ICreateCFWorkerWebsiteReq,
    ICreateCFWorkerWebsiteRes,
    ICreateDemoWebsiteUrlReq,
    IWebsiteUrlRecord,
} from "../types";

// ==================== Cloudflare Workers API ====================
const CLOUDFLARE_WORKERS_URL = "https://amaze-automation.brianhuang.workers.dev";

const cfBaseQuery = fetchBaseQuery({
    baseUrl: CLOUDFLARE_WORKERS_URL,
    timeout: 30000, // 30 seconds timeout for workflow processing
});

export const websiteDemoApiSlice = createApi({
    baseQuery: cfBaseQuery,
    reducerPath: "websiteDemoApiSlice",
    tagTypes: ["DemoWebsiteUrl"],
    endpoints: (builder) => ({
        createCFWorkerWebsite: builder.mutation<ICreateCFWorkerWebsiteRes, ICreateCFWorkerWebsiteReq>({
            query: (data) => ({
                url: "/webhook",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useCreateCFWorkerWebsiteMutation } = websiteDemoApiSlice;

// ==================== n8n API (Legacy for line hooks) ====================
const WEBSITE_ENDPOINT_MAP = {
    GET_DEMO_WEBSITE_URL: "/580c62e9-5805-42a0-a6dc-1fbf8652e3e2",
    CREATE_DEMO_WEBSITE_URL: "/3d4289fc-e841-468c-a97c-f622b087f27f",
};

export const n8nWebsiteDemoApiSlice = n8nApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDemoWebsiteUrl: builder.query<IWebsiteUrlRecord[], void>({
            query: () => ({
                url: WEBSITE_ENDPOINT_MAP.GET_DEMO_WEBSITE_URL,
            }),
            providesTags: ["n8n_DemoWebsiteUrl"],
        }),
        createDemoWebsiteUrl: builder.mutation<void, ICreateDemoWebsiteUrlReq>({
            query: (data) => ({
                url: WEBSITE_ENDPOINT_MAP.CREATE_DEMO_WEBSITE_URL,
                method: "POST",
                body: data,
            }),
            async onQueryStarted(data, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    n8nWebsiteDemoApiSlice.util.updateQueryData("getDemoWebsiteUrl", undefined, (draft) => {
                        draft.push({
                            ...data,
                            websiteUrl: `https://website.ai-amaze.com/${data.customUrl}`,
                            isActivated: "activated",
                            amazeVersion: data.projectVersion,
                        });
                    })
                );
                try {
                    await queryFulfilled;
                } catch {
                    patchResult.undo();
                }
            },
        }),
    }),
});

export const { useGetDemoWebsiteUrlQuery, useCreateDemoWebsiteUrlMutation } = n8nWebsiteDemoApiSlice;
